import React, { useEffect, useMemo, useState } from 'react';
import RuntimeConfigGridToolbar from './RuntimeConfigGridToolbar';
import RuntimeConfigGridPagination from './RuntimeConfigGridPagination';
import { BROWSE_PAGE_SIZE } from './runtimeConfigUtils';

const MimeGrid = ({ document, onEdit, onRemove, disabled }) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  const rows = useMemo(() => {
    const overrides = document?.data?.overrides || {};
    return Object.entries(overrides).map(([extension, contentType]) => ({
      extension,
      contentType,
    }));
  }, [document]);

  useEffect(() => {
    setPage(0);
  }, [document]);

  const filtered = useMemo(() => {
    const term = search.trim().toLowerCase();
    if (!term) {
      return rows;
    }
    return rows.filter((row) => {
      const extension = row.extension?.toLowerCase() || '';
      const contentType = row.contentType?.toLowerCase() || '';
      return extension.includes(term) || contentType.includes(term);
    });
  }, [rows, search]);

  const start = page * BROWSE_PAGE_SIZE;
  const pageRows = filtered.slice(start, start + BROWSE_PAGE_SIZE);

  const handleSearchChange = (value) => {
    setSearch(value);
    setPage(0);
  };

  if (!document) {
    return null;
  }

  return (
    <div className="runtime-config-grid-section" data-testid="mime-grid">
      <RuntimeConfigGridToolbar
        label="Filter MIME overrides"
        placeholder="Search extension or content-type…"
        value={search}
        onChange={handleSearchChange}
        testId="mime-search"
      />

      <table className="runtime-config-table">
        <thead>
          <tr>
            <th scope="col">Extension</th>
            <th scope="col">Content-Type</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {pageRows.length === 0 ? (
            <tr>
              <td colSpan="3" className="runtime-config-empty">No MIME overrides found.</td>
            </tr>
          ) : (
            pageRows.map((row) => (
              <tr key={row.extension}>
                <td>{row.extension}</td>
                <td>{row.contentType}</td>
                <td>
                  <button
                    type="button"
                    className="runtime-config-row-btn"
                    disabled={disabled}
                    aria-label={`Edit MIME extension ${row.extension}`}
                    onClick={() => onEdit({
                      isEdit: true,
                      editKey: row.extension,
                      action: 'merge',
                      formState: {
                        extension: row.extension,
                        contentType: row.contentType,
                      },
                    })}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="runtime-config-row-btn runtime-config-row-btn-danger"
                    disabled={disabled}
                    aria-label={`Remove MIME extension ${row.extension}`}
                    onClick={() => onRemove({ extension: row.extension })}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <RuntimeConfigGridPagination
        count={filtered.length}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
      />
    </div>
  );
};

export default MimeGrid;
